import { Injectable } from '@angular/core';
import {
  ICreditCardVendorReference,
  CreditCardReferences,
  CardType,
} from '@nibtravel/shared/util/models';

@Injectable()
export class CreditCardService {
  public isPanValid(pan: string): boolean {
    const parsedPan = this.parsePan(pan);
    const validLengths = this.getCardVendorRef(parsedPan).ValidLengths;
    const isValid = validLengths.some((length) => length.isValid(parsedPan));
    return isValid ? this.checkLuhn(parsedPan) : false;
  }

  public isCvcValid(cvc: string, pan: string): boolean {
    if (!cvc) {
      return false;
    }
    cvc = cvc.replace(/\D+/g, '');
    const cardVendorRef = this.getCardVendorRef(this.parsePan(pan));
    return cardVendorRef.CvcRegex
      ? cardVendorRef.CvcRegex.test(cvc.toString())
      : false;
  }

  public getCardType(pan: string): CardType {
    return this.getCardVendorRef(this.parsePan(pan)).Type;
  }

  public getCardVendorRef(pan: string): ICreditCardVendorReference {
    let cardType = CreditCardReferences[CardType.Other];
    if (pan) {
      const refKeys = Object.keys(CreditCardReferences);
      for (let index = 0; index < refKeys.length; index++) {
        const cardVendorRef = CreditCardReferences[refKeys[index]];
        if (cardVendorRef.NumberRegex.test(pan)) {
          cardType = cardVendorRef;
          break;
        }
      }
    }

    return cardType;
  }

  private parsePan(pan: string | undefined): string {
    return pan?.toString()?.replace(/\D/g, '') ?? '';
  }

  /**
   * Luhn checksum algorithm
   * See https://en.wikipedia.org/wiki/Luhn_algorithm
   */
  private checkLuhn(pan: string): boolean {
    let panLength = pan.length;
    let bit = 1;
    let sum = 0;
    let val;

    while (panLength) {
      val = parseInt(pan.charAt(--panLength), 10);
      bit ^= 1;
      sum += bit ? [0, 2, 4, 6, 8, 1, 3, 5, 7, 9][val] : val;
    }

    return sum !== 0 && sum % 10 === 0;
  }
}
